import dayjs from 'dayjs';
import getSummarySales from './getSummarySales';

export default function getTimezoneSalesData(
  or = [],
  d1 = [],
  d2 = [],
  d3 = []
) {
  const hours = Array.from({ length: 24 }, (_, index) => index);
  const newList = [...or, ...d1, ...d2, ...d3];

  const hourlyList = hours.reduce((acc, currentHour) => {
    acc[currentHour] = newList.filter((item) => {
      let day = 0;
      const {
        type,
        regular_payment_info,
        payment_date,
        rental_payment_info,
        payment_completion_date,
      } = item;

      if (payment_completion_date) {
        day = payment_completion_date;
      } else if (type === 'DELIVERY' || type === 'STORE_PICKUP') {
        day = payment_date;
      } else if (type === 'SUBSCRIPTION') {
        day = regular_payment_info?.payment_date;
      } else {
        day = rental_payment_info?.payment_date;
      }

      if (!day) return false;

      const itemHour = dayjs.unix(day).hour();

      return itemHour === currentHour;
    });

    return acc;
  }, {});

  const summaryData = getSummarySales(hourlyList);

  return summaryData;
}
